/**
 * Returns whether the given object matches the CesiumIonAssetStatus type
 * @param obj Object to check
 */
export function isCesiumIonAssetStatus(obj) {
    if (typeof obj !== "string")
        return false;
    switch (obj) {
        case "AWAITING_FILES" /* CesiumIonAssetStatus.AwaitingFiles */:
        case "NOT_STARTED" /* CesiumIonAssetStatus.NotStarted */:
        case "IN_PROGRESS" /* CesiumIonAssetStatus.InProgress */:
        case "COMPLETE" /* CesiumIonAssetStatus.Complete */:
        case "ERROR" /* CesiumIonAssetStatus.Error */:
        case "DATA_ERROR" /* CesiumIonAssetStatus.DataError */:
            return true;
        default:
            return false;
    }
}
